import React from "react";
import styled from "@emotion/styled";
import { Typography } from "../Typography";
import * as tokens from "../../design-tokens";

type FieldProps = {
  title: string;
  value: string;
  testId: string;
};

const Field = ({ title, value, testId }: FieldProps) => {
  return (
    <Container>
      <Typography size={tokens.FONT_SIZE_1} color={tokens.TINTS_OFF_WHITE_20}>
        {title}
      </Typography>
      <Typography size={tokens.FONT_SIZE_0} testId={testId}>
        {value}
      </Typography>
    </Container>
  );
};

const Container = styled.div`
  padding: 8px 0;
`;

export type { FieldProps };
export { Field };
